export const navigationItemDimensions = {
  height: 48,
  verticalSpacing: 2,
  horizontalInset: 12,
} as const;
